const BUSINESS_MODEL = {
  NON_FREE: 'nonFree',
  FREE: 'free',
};

Object.freeze(BUSINESS_MODEL);

export default BUSINESS_MODEL;
